import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {MerchantLogoCard, MerchantLogoCardStyle} from "../../../ui/MerchantCard";
import {WidgetActiveRouteElementBuilder} from "../../../ui/WidgetActiveRouteElement";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {SubscriptionIndex} from "./SubscriptionIndex";
import {DonationOverview} from "./DonationOverview";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {Color} from "../../../../../stem-core/src/ui/Color";
import {AddFundsMinimised} from "../../add-funds/sections/AddFundsMinimised";
import {Messages} from "../../../../Messages";
import {POPUP_GATE_TRANSITION_TIME} from "../../../../../blink-sdk/Constants";


class IndexHomeStyle extends MerchantLogoCardStyle {
    @styleRule
    buttonContainer = {};

    @styleRule
    subscriptionBordered = {
        paddingBottom: 12,
        borderBottom: "0.5px solid " + Color.addOpacity("#545f69", 0.12),
    };

    @styleRule
    emptyDescription = {
        paddingTop: 6,
        fontSize: 16,
        lineHeight: 24,
        textAlign: "center",
        color: this.themeProps.EMPTY_INDEX_EXPANDED_COLOR,
    };
}

@registerStyle(IndexHomeStyle)
export class IndexHome extends WidgetActiveRouteElementBuilder(MerchantLogoCard) {
    render() {
        if (!iFrameMerchantService.getMerchant().allowSubscriptions && !iFrameMerchantService.getMerchant().allowDonations) {
            return <div className={this.styleSheet.emptyDescription}>{Messages.emptyIndexExpandedDescription}</div>;
        }
        return [
            this.renderSubscriptionSection(),
            this.renderDonationSection()
        ];
    }

    renderSubscriptionSection() {
        if (!iFrameMerchantService.getMerchant().allowSubscriptions) {
            return null;
        }

        return <SubscriptionIndex className={iFrameMerchantService.getMerchant().allowDonations ?
                                             this.styleSheet.subscriptionBordered : ""}/>;
    }

    renderDonationSection() {
        if (!iFrameMerchantService.getMerchant().allowDonations) {
            return null;
        }

        return <DonationOverview/>;
    }

    renderSecondaryButton() {
        return null;
    }

    static show() {
        const {instance} = this;
        instance.redraw();
        instance.attachTimeout(() => instance.checkForScrollFadeDisplay(), POPUP_GATE_TRANSITION_TIME);
    }

    computeHeight() {
        const spaceFillHeight = !this.spaceFill ? 0 : this.spaceFill.getHeight();
        return this.getHeight() - spaceFillHeight + AddFundsMinimised.getHeight();
    }
}
